import { findKey, pick } from 'lodash'

const settlementMap = {
  0: '指定なし',
  1: '請求書',
  2: '事前決済済み',
  3: 'ポイント・クーポン利用',
  4: '現金',
  5: 'クレジットカード',
  6: '電子マネー',
  7: 'スマート支払い',
  99: 'その他',
}

export default settlementMap

export function getSettlementCodeByStr(settlementStr) {
  return parseInt(
    findKey(settlementMap, mapStr => mapStr === settlementStr),
    10,
  )
}

export const getSettlementMapBySyncType = (syncType, value) => {
  // 決済方法がポイント決済またはクーポン利用
  if (value === 3) return pick(settlementMap, [3])
  // ぐるなび法人予約サービス
  if (syncType === 5) return pick(settlementMap, [1])
  // ぐるなび外国語版
  if (syncType === 6) return pick(settlementMap, [2])

  // 項目の並び順指定あり
  const list = syncType !== 10 ? [0, 4, 5, 6, 1, 99] : [0, 4, 5, 6, 7, 1, 99]
  return new Map(list.map(key => [key, settlementMap[key]]))
}

export const pointPayment = settlement => [3, 7].includes(settlement)
